<template>
  <section>
    <h1>退会されています。</h1>
    <p>
      お客様はすでに退会済みとなっております。<br>
      ご利用ありがとうございました。
    </p>
    <p>お問い合わせは下記のメールアドレスにお送り下さい。</p>
    <p>運営事務局：{{ settingData.inquiry_mail }}</p>
  </section>
</template>

<script>
export default {
  name: 'RestrictionWithdrawal',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  },
  methods: {
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
